// Recovered compiled webpack factory 74061. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      normalizeAppPath: function () {
        return o;
      },
      normalizeRscURL: function () {
        return i;
      },
    }));
  let n = r(76196),
    a = r(65360);
  function o(e) {
    return (0, n.ensureLeadingSlash)(
      e
        .split("/")
        .reduce(
          (e, t, r, n) =>
            !t ||
            (0, a.isGroupSegment)(t) ||
            "@" === t[0] ||
            (("page" === t || "route" === t) && r === n.length - 1)
              ? e
              : e + "/" + t,
          "",
        ),
    );
  }
  function i(e) {
    return e.replace(/\.rsc($|\?)/, "$1");
  }
}
